import { GetStaticProps } from "next";
import { LocationAnnoncesLp } from "page/locationAnnoncesLp";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import LPGetStaticProps from "utils/LpGetStaticProps";
import { NEW_LP_DATA_QUERY } from "../../page/query";
import { PageData } from "../../page/types";
import { actions as urltrackActions } from "../../redux/slices/newLps/FillDarian";
import { query } from "pages/louer/guide-location/[slug]";
import getArticlesListingPages from "pagesHelpers/ArticlesInPagesAnnonces";
import { client } from "../../sanity/client";
interface PageProps {
  data: PageData | null;
  preview: boolean;
  slug?: string | null;
  token: string | null;
  listings?: any[];
  articleData?: any | null;
}

interface Query {
  [key: string]: string;
}

interface PreviewData {
  token?: string;
}

export const getStaticProps: GetStaticProps<
  PageProps,
  Query,
  PreviewData
> = async (ctx) => {
  const { params = {}, preview = false, previewData = {} } = ctx;
  let query_post = query;

  return LPGetStaticProps(ctx, "Location", "louer", NEW_LP_DATA_QUERY)
    .then(async (res: any) => {
      const article = getArticlesListingPages("Location");
      if (article) {
        return {
          ...res,
          props: {
            ...res.props,
            articleData: await client.fetch(query_post, { slug: article }),
          },
        };
      } else {
        return res;
      }
    })
    .catch((err) => {
      return {
        notFound: true,
      };
    });
};
export default function Page(props: PageProps) {
  const { data, slug, token, listings, articleData } = props;
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      urltrackActions.setPage([{ name: "Location", path: "/location" }])
    );
  }, []);

  if (data) {
    return (
      <LocationAnnoncesLp
        articleData={articleData}
        listings={listings}
        data={data}
        slug={slug}
      />
    );
  }
}
